import { jsx as _jsx } from "react/jsx-runtime";
import { List as MuiList } from '@mui/material';
import { styled } from '../../utils';
export function List(props) {
    return _jsx(ListStyled, { ...props, paddingLeft: props.paddingLeft ?? '0px' });
}
const ListStyled = styled(MuiList, {
    shouldForwardProp: (prop) => prop !== 'paddingLeft',
})(({ paddingLeft }) => ({
    width: '100%',
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft,
}));
